/* ==========================================================================
   FreshClick — Product tabs helpers (Beauty Lounge)
   Consolidat din 2 scripturi inline care se randau de 8x pe fiecare PDP
   (4 collapsible_tab x 2 randari: desktop below-media + mobil info column).
   Se incarca o singura data, din theme.liquid, cu defer.
   ========================================================================== */

/* --------------------------------------------------------------------------
   1. Repozitionare widget Judge.me in tabul Recenzii
   -------------------------------------------------------------------------- */
(function () {
  if (window.__fcJmPlace) return;
  window.__fcJmPlace = true;

  var jm, sec, tab;

  function getEls() {
    jm = document.getElementById('judgeme_product_reviews');
    if (!jm) return false;
    sec = jm.closest('.shopify-section');
    var tabs = document.querySelectorAll('.accordion-details--judgeme');
    tab = null;
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].offsetParent !== null) { tab = tabs[i]; break; }
    }
    if (!tab) tab = tabs[0];
    return !!(sec && tab);
  }

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function alignLeft() {
    if (!jm || !tab) return;
    if (isMobile()) { jm.style.marginLeft = ''; return; }
    if (sec.style.display === 'none') return;
    /* setarea margin-left anuleaza centrarea "auto", deci pozitia se schimba
       chiar in timpul corectiei -> iteram pana converge la marginea tab-ului */
    for (var i = 0; i < 4; i++) {
      var delta = tab.getBoundingClientRect().left - jm.getBoundingClientRect().left;
      if (Math.abs(delta) < 1) break;
      var current = parseFloat(jm.style.marginLeft) || 0;
      jm.style.marginLeft = (current + delta) + 'px';
    }
  }

  function syncVisibility() {
    if (!sec || !tab) return;
    if (isMobile()) { sec.style.display = ''; return; }
    sec.style.display = tab.hasAttribute('open') ? '' : 'none';
    if (tab.hasAttribute('open')) requestAnimationFrame(alignLeft);
  }

  function place() {
    if (!getEls()) return false;
    if (isMobile()) {
      var content = tab.querySelector('.accordion-details__content');
      if (!content) return false;
      if (!content.contains(sec)) content.appendChild(sec);
    } else {
      var productSec = document.querySelector('product-info')
        ? document.querySelector('product-info').closest('.shopify-section')
        : null;
      if (!productSec) return false;
      if (sec.previousElementSibling !== productSec) {
        productSec.insertAdjacentElement('afterend', sec);
      }
    }
    syncVisibility();
    return true;
  }

  function init() {
    if (!place()) return;
    tab.addEventListener('toggle', syncVisibility);
    window.addEventListener('resize', function () {
      place();
      requestAnimationFrame(alignLeft);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 600);
  setTimeout(init, 1600);
})();

/* --------------------------------------------------------------------------
   2. Scroll la titlul tabului cand se deschide un accordion
   -------------------------------------------------------------------------- */
(function () {
  if (window.__fcAccordionScrollToTitle) return;
  window.__fcAccordionScrollToTitle = true;

  /* offset suplimentar sub header (px) ca titlul sa nu fie lipit de el */
  var GAP = 12;

  function headerOffset() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var h = parseInt(v, 10);
    if (isNaN(h)) h = 0;
    return h + GAP;
  }

  function scrollSummaryUnderHeader(summary) {
    var top = summary.getBoundingClientRect().top + window.scrollY - headerOffset();
    window.scrollTo({ top: top, left: 0, behavior: 'auto' });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var summary = e.target.closest('.accordion-details__summary');
    if (!summary) return;
    var details = summary.closest('details.accordion-details');
    if (!details) return;

    /* Starea ARIA inainte de toggle: daca era deschis, acum se inchide -> ignoram. */
    var wasOpen = details.hasAttribute('open');
    if (wasOpen) return;

    /* Tab-ul se DESCHIDE. Asteptam ca layout-ul (colaps tab vechi + expand
       tab nou) sa se aseze, apoi pozitionam titlul sub header.
       Doua corectii: una rapida (dupa primul reflow) si una dupa animatie. */
    requestAnimationFrame(function () {
      scrollSummaryUnderHeader(summary);
    });

    /* dupa ce se termina animatia temei (~300-450ms uzual) */
    setTimeout(function () {
      scrollSummaryUnderHeader(summary);
    }, 450);
  }, true);
})();